import React from 'react';

import LetterItem from './Item';

class LetterList extends React.Component {

    render() {
        const { letters } = this.props;
        const lettersData = letters.data;

        if (!lettersData) {
            return null;
        }

        return (
            <div>
                <ul className='letters-collection collection'>
                    {
                        lettersData.map(letter => <LetterItem key={letter._id} item={letter} />)
                    }
                </ul>
            </div>
        );
    }
}

export default LetterList;



// WEBPACK FOOTER //
// ./app/components/Letters/List/List.jsx